import React from 'react';

import cx from 'classnames';
import Sticky from 'react-sticky-el';

import MobileNav from 'components/Layouts/Form/FormBuilder/MobileNav';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './index.module.css';
import { IWrapperProps } from './types';

export function Wrapper(props: IWrapperProps) {
  const { links, children, disabled, isEmpty = false } = props;
  const { isTabletOrMobile } = useMediaBreakpoints();
  const showMobileNav = links?.length > 0;
  const showHeader = isTabletOrMobile ? !isEmpty : true;

  return (
    <Sticky
      scrollElement={`#${LANDING_PAGES_CONTAINER_ID}`}
      stickyStyle={{ zIndex: '6' }}
      topOffset={-90}
      positionRecheckInterval={1}
    >
      {showHeader && (
        <div className={cx(s.pageHeader, disabled && s.pageHeaderDisabled, 'custom-right-page-header')}>{children}</div>
      )}
      {/*@ts-ignore*/}
      {showMobileNav && isTabletOrMobile && <MobileNav navigation id="mobileNav" links={links} />}
    </Sticky>
  );
}
